// src/components/LoginLogout.js
import React from "react";
import { useKeycloak } from "../KeycloakProvider";

import GoogleIcon from '@mui/icons-material/Google';
import MicrosoftIcon from '@mui/icons-material/Microsoft';
import GitHubIcon from '@mui/icons-material/GitHub';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const LoginLogout = () => {
    const { keycloak, authenticated } = useKeycloak();

    const handleLogin = () => {
        if (keycloak) keycloak.login({ redirectUri: window.location.origin });
    };

    const handleLogout = () => {
        if (keycloak) keycloak.logout({ redirectUri: window.location.origin });
    };

    return (
        <div>
            {authenticated ? (
                <button className="py-4 px-6 w-[300px] rounded-sm text-[14px] bg-warmGray-200/95 text-warmGray-950/90 transition-all duration-200 hover:bg-warmGray-50" onClick={handleLogout}>LOGOUT</button>
            ) : (<>
                <div className="grid grid-cols-1 py-4">
                    {/* <div className="col-span-1 text-center p-4 scale-150">
                        <GoogleIcon />
                    </div> */}
                    <div className="col-span-1 text-center p-4 scale-150">
                        <MicrosoftIcon />
                    </div>
                    {/* <div className="col-span-1 text-center p-4 scale-150">
                        <GitHubIcon />
                    </div> */}
                </div>
                <button className="py-4 px-6 w-[300px] rounded-sm text-[14px] bg-warmGray-200/95 text-warmGray-950/90 transition-all duration-200 hover:bg-warmGray-50" onClick={handleLogin}>LOGIN</button>
            </>
            )}
        </div>
    );
};

export default LoginLogout;
